import FormattedPrice from 'payments-checkout-lib/components/Utilities/FormattedPrice';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { Text } from 'foundations-components/components/Text';
import { HR } from 'foundations-components/transitional/components/HR';
import useBuyerOverridesLoading from '../../hooks/useBuyerOverridesLoading';
import AppliedCreditMemo from './AppliedCreditMemo';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const BalanceDueSummary = ({
  amountPaid = 0,
  balanceDue,
  creditMemos = [],
  currencyCode,
  leftGridSize,
  rightGridSize
}) => {
  const isBuyerOverridesLoading = useBuyerOverridesLoading();
  const showAmountPaid = amountPaid > 0;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [creditMemos.map(creditMemo => /*#__PURE__*/_jsx(AppliedCreditMemo, {
      creditMemoNumber: creditMemo.creditMemoNumber,
      creditAmountApplied: creditMemo.amountApplied,
      isBuyerOverridesLoading: isBuyerOverridesLoading,
      currencyCode: currencyCode,
      leftGridSize: leftGridSize,
      rightGridSize: rightGridSize
    }, creditMemo.creditMemoNumber)), showAmountPaid && /*#__PURE__*/_jsxs(Grid, {
      paddingInline: "600",
      paddingBlockEnd: "600",
      children: [/*#__PURE__*/_jsx(GridItem, {
        size: leftGridSize,
        children: /*#__PURE__*/_jsx(Text, {
          typography: "body-125",
          marginBlockEnd: "200",
          textAlign: "start",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "payments.amountPaid"
          })
        })
      }), /*#__PURE__*/_jsx(GridItem, {
        "data-test-id": "amount-paid",
        size: rightGridSize,
        children: /*#__PURE__*/_jsx(Text, {
          typography: "body-125",
          marginBlockEnd: "200",
          textAlign: "end",
          color: isBuyerOverridesLoading ? 'text-core-disabled' : 'text-core-default',
          children: /*#__PURE__*/_jsx(FormattedPrice, {
            currencyCode: currencyCode,
            price: -amountPaid,
            currencyAndAmountStyle: {
              color: isBuyerOverridesLoading ? 'text-core-disabled' : 'text-core-default'
            }
          })
        })
      })]
    }), /*#__PURE__*/_jsx(HR, {
      distance: "medium",
      marginBlockStart: "0"
    }), /*#__PURE__*/_jsxs(Grid, {
      paddingInline: "600",
      paddingBlockEnd: "600",
      children: [/*#__PURE__*/_jsx(GridItem, {
        size: leftGridSize,
        children: /*#__PURE__*/_jsx(Text, {
          as: "h4",
          marginBlockEnd: "200",
          textAlign: "start",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "payments.balanceDue",
            options: {
              currencyCode
            }
          })
        })
      }), /*#__PURE__*/_jsx(GridItem, {
        "data-test-id": "balance-due",
        size: rightGridSize,
        children: /*#__PURE__*/_jsx(Text, {
          as: "h4",
          marginBlockEnd: "200",
          textAlign: "end",
          color: isBuyerOverridesLoading ? 'text-core-disabled' : 'text-core-default',
          children: /*#__PURE__*/_jsx(FormattedPrice, {
            currencyCode: currencyCode,
            price: balanceDue,
            currencyAndAmountStyle: {
              color: isBuyerOverridesLoading ? 'text-core-disabled' : 'text-core-default'
            }
          })
        })
      })]
    })]
  });
};
export default BalanceDueSummary;